import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';
import carfaxLogo from 'public/static/images/vdp/carfax.svg';

export default css`
  .price-analysis {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .flex-container {
    display: flex;
    justify-content: space-between;
    margin: 20px 0px;
  }

  h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: ${colors.BLACK};
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }

  @media (min-width: ${screen.smMin}) {
    h2 {
      font-size: 20px;
    }
  }

  .carfax {
    display: none;
  }

  .carfax-mobile {
    padding: 18px 0px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border-top: 1px solid ${colors.G2};
  }

  @media (min-width: ${screen.smMin}) {
    .carfax {
      display: flex;
      align-items: center;
      text-decoration: none;
    }
  }

  @media (min-width: ${screen.smMin}) {
    .carfax-mobile {
      display: none;
    }
  }

  .carfax-mobile .text {
    font-weight: 400;
    font-size: 14px;
    margin-right: 8px;
    color: ${colors.BLACK};
  }

  .carfax .text {
    font-weight: 400;
    font-size: 14px;
    margin-right: 8px;
    color: ${colors.BLACK};
  }

  @media (min-width: ${screen.smMin}) {
    .carfax .text {
      font-size: 16px;
    }
  }

  .carfax-logo {
    background-image: url(${carfaxLogo});
    background-size: cover;
    width: 126px;
    height: 24px;
  }

  .not-enough-data {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 76px;
    font-size: 16px;
    color: ${colors.G3};
    letter-spacing: 0.2px;
  }

  @media (min-width: ${screen.smMin}) {
    .not-enough-data {
      height: 95px;
    }
  }

  .market-price {
    position: relative;
  }

  .market-price-bar {
    width: 100%;
    height: 12px;
    // special one time colors for gradient green yellow red
    background: linear-gradient(90deg, #00a324 0%, #ffba53 50.52%, #d31c32 100%);
    border-radius: 100px;
  }

  @media (min-width: ${screen.smMin}) {
    .market-price-bar {
      height: 16px;
    }
  }

  .market-price-text {
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;
  }

  @media (min-width: ${screen.smMin}) {
    .market-price-text {
      margin: 0;
    }
  }

  .item {
    width: 98px;
  }

  @media (min-width: ${screen.smMin}) {
    .item {
      width: 164px;
    }
  }

  .title {
    color: ${colors.BLACK};
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.2px;
    margin-bottom: 4px;
  }

  @media (min-width: ${screen.smMin}) {
    .title {
      font-size: 18px;
    }
  }

  .sub-title {
    font-size: 12px;
    line-height: 16px;
  }

  @media (min-width: ${screen.smMin}) {
    .sub-title {
      display: block;
      color: ${colors.G3};
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  .above-market {
    text-align: right;
  }

  .market-price {
    text-align: center;
  }

  .below-market {
    text-align: left;
  }

  .dot {
    background-color: ${colors.WHITE};
    border-radius: 50%;
    width: 10px;
    height: 10px;
    margin-top: 12px;
  }

  @media (min-width: ${screen.smMin}) {
    .dot {
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
  }
`;
